import { render, staticRenderFns } from "./ListReports.vue?vue&type=template&id=2a5c860d&scoped=true"
import script from "./ListReports.vue?vue&type=script&lang=js"
export * from "./ListReports.vue?vue&type=script&lang=js"
import style0 from "./ListReports.vue?vue&type=style&index=0&id=2a5c860d&prod&scoped=true&lang=css"
import style1 from "./ListReports.vue?vue&type=style&index=1&id=2a5c860d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c860d",
  null
  
)

export default component.exports